import { create } from 'zustand'

interface IUsePushPromptStore {
  valueMomentReached: boolean
  reachValueMoment: () => void
}

export const usePushPromptStore = create<IUsePushPromptStore>((set) => ({
  valueMomentReached: false,
  reachValueMoment: () => set({ valueMomentReached: true }),
}))
